function PendingApplications(config, renderer) {
  this.init = function () {
    return {}
  }

  this.done = function () {
    Fetch.get('/application/second-pillar/pending-exchange-applications').then(renderApplications);
  }

  function renderApplications(applications) {
    $('#pending-application-list').html(renderer.render('pending-applications-template', {
      applications: applications
    })).fadeIn()
  }
}